import { Component } from '@angular/core';

@Component({
  selector: 'app-section-servicos-e-cursos',
  templateUrl: './section-servicos-e-cursos.component.html',
  styleUrls: ['./section-servicos-e-cursos.component.scss'],
})
export class SectionServicosECursosComponent {}
